import React, { useEffect, useState } from 'react';
import { getImageSrc } from '../../../util';
import { FullBackground } from '../../../components/FullBackground';

type Props = {
  className?: string;
};

const ProductDigitalMenus: React.FC<Props> = ({ className }) => {
  const [index, set] = useState(0);

  useEffect(
    () => void setInterval(() => set(state => (state + 1) % 5), 4000),
    [],
  );
  return (
    <>
      <FullBackground color={'bg-gray-50'} isSlanted={false} shadow={false}>
        <div
          className={`relative py-16 lg:py-16 xl:-mb-64 lg:-mb-96 md:-mb-80 sm:-mb-64 -mb-60 ${className}`}
          id={'digital-menus'}
          style={{ marginLeft: '50vw', marginRight: '50vw' }}
        >
          <div className="relative max-w-xl max-w-7xl">
            <div className="relative mt-2 lg:grid lg:grid-cols-2 lg:gap-8 lg:items-start">
              <div className="relative">
                <div className="max-w-3xl mx-auto text-left xl:mt-24 lg:mt-20">
                  <h2 className="text-base text-primary-600 font-semibold tracking-wide uppercase">
                    Digital Mobile Menus
                  </h2>
                  <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                    Eye contact is powerful.
                  </p>
                </div>
                <div className="text-xl text-gray-700 sm:text-xl mt-4 xl:mt-6">
                  <p>
                    TableTab menus are a cost-effective, sustainable, and
                    engaging solution to displaying the best version of your
                    offerings to guests.
                  </p>
                </div>
                <div className="mt-10 mb-8 xl:grid xl:grid-cols-2 xl:gap-x-6 xl:gap-y-10 space-y-10 xl:space-y-0">
                  <div className="flex">
                    <div className="">
                      <dt className="text-lg leading-6 font-medium text-gray-900">
                        Responsive
                      </dt>
                      <dd className="mt-2 text-base text-gray-500">
                        Our interface ensures your guests can easily read and
                        navigate your menu.
                      </dd>
                    </div>
                  </div>
                  <div className="flex">
                    <div className="">
                      <dt className="text-lg leading-6 font-medium text-gray-900">
                        Visual
                      </dt>
                      <dd className="mt-2 text-base text-gray-500">
                        As good as words might make your dish sound, nothing
                        beats a picture.
                        {/* <a
                          id={'dvmFtw'}
                          href={
                            '/compare/pdfs?ref=product_digital_menus_dvmFtw_inline'
                          }
                          className={'text-primary-600 hover:text-primary-700'}
                          onClick={() => {
                            // e.preventDefault();
                            // @ts-ignore
                            analytics.track('Compare Clicked', {
                              title: 'no_more_zooming_in',
                              action: 'click',
                              location: 'product_digital_menus',
                              destination: 'compare_pdfs_hero',
                            });
                            // history.push('/use-cases/fsr#margin-impact?ref=home_product_aoBx9N_inline')
                          }}
                        >
                          no more zooming in!
                        </a> */}
                      </dd>
                    </div>
                  </div>
                  <div className="flex">
                    <div className="">
                      <dt className="text-lg leading-6 font-medium text-gray-900">
                        Informative
                      </dt>
                      <dd className="mt-2 text-base text-gray-500">
                        Educate guests on your items, list your modifiers,
                        suggest pairings, and more.
                      </dd>
                    </div>
                  </div>
                  <div className="flex">
                    <div className="">
                      <dt className="text-lg leading-6 font-medium text-gray-900">
                        Smart
                      </dt>
                      <dd className="mt-2 text-base text-gray-500">
                        Display the right menu automatically and real-time menu
                        updates instantly.
                      </dd>
                    </div>
                  </div>
                  {/* <div className="flex">
                    <div className="">
                      <dt className="text-lg leading-6 font-medium text-gray-900">
                        Update in real time
                      </dt>
                      <dd className="mt-2 text-base text-gray-500">
                        Make menu changes instantly via our dashboard and easily
                        test new offerings.
                      </dd>
                    </div>
                  </div>
                  <div className="flex">
                    <div className="">
                      <dt className="text-lg leading-6 font-medium text-gray-900">
                        Personalize the experience
                      </dt>
                      <dd className="mt-2 text-base text-gray-500">
                        Include your restaurant's story, or add a message for
                        guests (i.e. a reminder to wear masks!).
                      </dd>
                    </div>
                  </div> */}
                </div>
                <div className="mt-4 xl:mt-6 flex">
                  <div className="mt-3 text-base">
                    <a
                      href="https://get.tabletab.io/menus?ref=product-digital-menus"
                      className="font-medium text-primary-600 hover:text-primary-500"
                    >
                      {' '}
                      Learn more about our menus and the unmatched ease in
                      managing them <span aria-hidden="true">&rarr;</span>
                    </a>
                    {/* <a
                      href={
                        'https://get.tabletab.io/menus?ref=product-digital-menus'
                      }
                      target={'_blank'}
                      className="inline-flex items-center justify-center px-5 rounded-full hover:text-white py-1 border border-transparent text-base font-medium rounded-full text-white bg-primary-600 hover:bg-primary-500"
                    >
                      Learn more about our menus and the unmatched simplicity in managing them
                    </a> */}
                  </div>
                </div>
              </div>

              <div
                className="mt-10 relative lg:mt-0 xl:-mr-80 2xl:-mr-96 xl:ml-20 2xl:ml-40 lg:-mr-40"
                aria-hidden="true"
              >
                <div className="relative py-3 w-3/4 lg:w-full mx-auto">
                  {/*<div className="absolute px-4 py-10 bg-white shadow-lg rounded-2xl sm:rounded-3xl sm:p-20 bg-primary-600" />*/}
                  <div
                    className={
                      'relative  bg-white shadow-lg sm:rounded-3xl lg:1/5 md:3/4 xl:w-1/2 mx-auto '
                    }
                  >
                    <picture className="lazyload">
                      <source
                        srcSet={getImageSrc('product_digital_menu_v1.webp')}
                        type="image/webp"
                      />
                      <source
                        srcSet={getImageSrc('product_digital_menu_v1.png')}
                        type="image/png"
                      />
                      <img
                        className=" lazyload rounded-lg object-cover "
                        style={{ height: 'auto', width: '100%' }}
                        data-src={getImageSrc('product_digital_menu_v1.webp')}
                        alt="digital menu"
                      />
                    </picture>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </FullBackground>
    </>
  );
};

export default ProductDigitalMenus;
